import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4134806a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "basic-personal-data-component" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "step-info-small" }, " Insira corretamente os dados da pessoa que fez o autoteste, eles aparecerão no seu cartão de resultado. ", -1))
const _hoisted_3 = { class: "form-container" }
const _hoisted_4 = { class: "info-age" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Você possui menos de 14 anos. Ao prosseguir, você confirma que realizou o teste sob a supervisão de um adulto responsável.", -1))
const _hoisted_6 = [
  _hoisted_5
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_input = _resolveComponent("base-input")!
  const _component_base_select = _resolveComponent("base-select")!
  const _component_floating_card = _resolveComponent("floating-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_floating_card, {
      ref: "base-modal",
      stepNumber: "7",
      stepTitle: "Informe os primeiros dados pessoais",
      nextButtonActive: _ctx.canJumpNext,
      btnNextLabel: "Continuar",
      onNextStep: _cache[3] || (_cache[3] = ($event: any) => (this.$emit('nextStep'))),
      onPreviousStep: _cache[4] || (_cache[4] = ($event: any) => (this.$emit('previousStep')))
    }, {
      content: _withCtx(() => [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_base_input, {
            type: "text",
            ref: "form-name",
            id: "form-name",
            label: "Nome completo:",
            placeholder: "Nome e sobrenome",
            validatorType: _ctx.nameFieldValidations,
            modelValue: _ctx.patient.name,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.patient.name) = $event)),
            required: "",
            requiredSign: ""
          }, null, 8, ["validatorType", "modelValue"]),
          _createVNode(_component_base_input, {
            type: "text",
            ref: "form-birthdate",
            id: "form-birthdate",
            inputmode: "numeric",
            label: "Data de nascimento:",
            placeholder: "DD/MM/AAAA",
            validatorType: _ctx.birthDateFieldValidations,
            validatorParams: 14,
            customErrorMsg: _ctx.ageErrorMsg,
            mask: "##/##/####",
            modelValue: _ctx.patient.birthdate,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.patient.birthdate) = $event)),
            onKeyup: _ctx.ageForm,
            required: "",
            requiredSign: ""
          }, null, 8, ["validatorType", "customErrorMsg", "modelValue", "onKeyup"]),
          _createVNode(_component_base_select, {
            type: "text",
            ref: "form-gender",
            id: "form-gender",
            label: "Sexo:",
            placeholder: "Selecione",
            validatorType: _ctx.genderFieldValidations,
            availableOptions: _ctx.genderOptions,
            modelValue: _ctx.patient.gender,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.patient.gender) = $event)),
            required: "",
            requiredSign: ""
          }, null, 8, ["validatorType", "availableOptions", "modelValue"])
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_4, _hoisted_6, 512), [
          [_vShow, _ctx.msg]
        ])
      ]),
      _: 1
    }, 8, ["nextButtonActive"])
  ]))
}